export const ROLES = {
  User: 2001, // User
  Approver: 1984, // Approver
  Admin: 5150, //Admin
  Superadmin: 6213, // Superadmin
};

const allowedToSuperadmin = [ROLES.Superadmin];
const allowedToAdmin = [ROLES.Admin, ROLES.Superadmin];
const allowedToApprover = [ROLES.Admin, ROLES.Superadmin, ROLES.Approver];

const isSuperadmin = (roles) => {
  return roles?.find((role) => allowedToSuperadmin?.includes(role)) != null;
};

const isApprover = (roles) => {
  return roles?.find((role) => allowedToApprover?.includes(role)) != null;
};

const isAdmin = (roles) => {
  return roles?.find((role) => allowedToAdmin?.includes(role)) != null;
};

const isAllowedToSetUserRights = (roles) => isAllowedToViewUsers(roles);
const isAllowedToSetApproverRights = (roles) => isAdmin(roles);
const isAllowedToSetAdminRights = (roles) => isSuperadmin(roles);
const isAllowedToSetAllRights = (roles) => isSuperadmin(roles);

const isAllowedToDownloadUsers = (roles) => isAdmin(roles);
const isAllowedToDeleteUsers = (roles) => isApprover(roles);
const isAllowedToViewRegisterSettings = (roles) => isAdmin(roles);

const isAllowedToViewTables = (roles) => isSuperadmin(roles);
const isAllowedToViewUsers = (roles) => isApprover(roles);

export {
  isAllowedToViewTables,
  isAllowedToViewRegisterSettings,
  isAllowedToViewUsers,
  isAllowedToSetUserRights,
  isAllowedToSetApproverRights,
  isAllowedToSetAdminRights,
  isAllowedToSetAllRights,
  isAllowedToDeleteUsers,
  isAllowedToDownloadUsers,
};
